module.exports = __webpack_public_path__ + "img/icon-video@2x.a06f0189.png";